module.exports = __webpack_public_path__ + "img/logo.e65a5e48.svg";